/**
 * Shared merge helpers for sticky-filter hydration from sessionStorage.
 */

/** Returns a positive page number, or 1 when invalid. */
export function mergePositivePageNumber(value) {
  return typeof value === "number" && value > 0 ? value : 1;
}

/**
 * Hydrates a single-column sort config `{ [column]: { direction } }`.
 * Falls back to defaultSortConfig when saved value is missing/invalid.
 */
export function mergeSingleColumnSortConfig(saved, defaultSortConfig) {
  if (!saved || typeof saved !== "object") {
    return { ...defaultSortConfig };
  }

  const keys = Object.keys(saved);
  if (keys.length === 0) {
    return { ...defaultSortConfig };
  }

  const columnKey = keys[0];
  const direction = saved[columnKey]?.direction;
  if (direction !== "asc" && direction !== "desc") {
    return { ...defaultSortConfig };
  }

  return { [columnKey]: { direction } };
}
